module.exports = __webpack_public_path__ + "static/media/nag4.14b0e25a.png";